import React, { useEffect, useState } from "react";
import { useCourse } from "context/context";
import { useNavigate } from "react-router-dom";

export default function MentorShipCourseSelection() {
    const { myallCourses, mentorfindstudentformflag } = useCourse();
    const [selectedMentorshipCourse, setSelectedMentorshipCourse] = useState(null);
    const [selectedMentorshipCourseTitle, setSelectedMentorshipCourseTitle] = useState(null);
    const navigate = useNavigate();
    const isMobileOrTablet = window.innerWidth <= 768;

    const mentorshipCourses = myallCourses?.filter((c) => c.Mentorship === "Y");

    // Auto-select the first course by default
    useEffect(() => {
        if (mentorshipCourses?.length > 0 && !selectedMentorshipCourse) {
            setSelectedMentorshipCourse(mentorshipCourses[0].CourseID);
            setSelectedMentorshipCourseTitle(mentorshipCourses[0].CourseTitle);
        }
    }, [mentorshipCourses]);

    // Show loader if courses are not yet available or still empty
    if (!myallCourses || myallCourses.length === 0) {
        return (
            <div style={styles.loaderContainer}>
                <div className="spinner-border text-danger" style={styles.spinner} role="status">
                    <span className="sr-only"></span>
                </div>
                <p style={styles.loadingText}>Loading courses...</p>
            </div>
        );
    }

    return (
        <div style={styles.maincontainerstyle}>
            <div style={styles.pageWrapper}>
                <div style={styles.card}>
                    <h2 style={styles.title}>Select a Mentorship Course</h2>

                    <div style={styles.courseList}>
                        {mentorshipCourses?.map((course) => (
                            <div
                                key={course.CourseID}
                                onClick={() => {
                                    setSelectedMentorshipCourse(course.CourseID);
                                    setSelectedMentorshipCourseTitle(course.CourseTitle);
                                }}
                                style={{
                                    ...styles.courseItem,
                                    backgroundColor:
                                        selectedMentorshipCourse === course.CourseID ? "#f9f9f9" : "#fff",
                                    borderColor:
                                        selectedMentorshipCourse === course.CourseID ? "#DD5D59" : "#ccc",
                                }}
                            >
                                <label style={styles.label}>
                                    <input
                                        type="radio"
                                        name="mentorship"
                                        value={course.CourseID}
                                        checked={selectedMentorshipCourse === course.CourseID}
                                        onChange={() => {
                                            setSelectedMentorshipCourse(course.CourseID);
                                            setSelectedMentorshipCourseTitle(course.CourseTitle);
                                        }}
                                        style={styles.radio}
                                    />
                                    <a style={{ textAlign: "center" }}>{course.CourseTitle}</a>
                                </label>
                            </div>
                        ))}
                    </div>

                    <div
                        style={{
                            ...styles.buttonRow,
                            justifyContent: isMobileOrTablet ? "center" : "flex-end",
                        }}
                    >
                        <button
                            style={{
                                ...styles.button,
                                backgroundColor: selectedMentorshipCourse ? "#DD5D59" : "#ccc",
                                cursor: selectedMentorshipCourse ? "pointer" : "not-allowed",
                            }}
                            disabled={!selectedMentorshipCourse}
                            onClick={() => {
                                if (!selectedMentorshipCourse) return;
                                if (mentorfindstudentformflag === true) {
                                    navigate("/dashboard/book-mentor-appointment", {
                                        state: {
                                            fromDashboardMentorModal: true,
                                            mentorCourseSelected: selectedMentorshipCourse,
                                            mentorCourseSelectedTitle: selectedMentorshipCourseTitle,
                                        },
                                    });
                                } else {
                                    navigate("/dashboard/student-mentorship-form", {
                                        state: {
                                            fromDashboardMentorModal: true,
                                            mentorCourseSelected: selectedMentorshipCourse,
                                            mentorCourseSelectedTitle: selectedMentorshipCourseTitle,
                                        },
                                    });
                                }
                            }}
                        >
                            Book Appointment
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

// 🔧 Styles
const styles = {
    maincontainerstyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        backgroundColor: "#f7f7f9",
        minHeight: "90vh",
    },
    pageWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "70vh",
        backgroundColor: "#f7f7f9",
        padding: "1rem",
        overflow: "hidden",
    },
    card: {
        backgroundColor: "#fff",
        padding: "2rem",
        borderRadius: "12px",
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
        width: "100%",
        maxWidth: "500px",
    },
    title: {
        textAlign: "center",
        fontSize: "20px",
        fontWeight: 600,
        marginBottom: "1.5rem",
    },
    courseList: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        maxHeight: "300px",
        overflowY: "auto",
        paddingRight: "0.5rem",
    },
    courseItem: {
        padding: "1rem",
        borderRadius: "8px",
        border: "1px solid #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease",
    },
    label: {
        display: "flex",
        alignItems: "center",
        fontWeight: 500,
        cursor: "pointer",
        gap: "1.7rem",
        marginBottom: "0px",
    },
    radio: {
        transform: "scale(1.4)",
        cursor: "pointer",
    },
    buttonRow: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "2rem",
    },
    button: {
        padding: "0.6rem 1.2rem",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        fontWeight: 500,
        transition: "all 0.2s ease",
    },

    // Loader styles
    loaderContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#f7f7f9",
    },
    spinner: {
        width: "3rem",
        height: "3rem",
        marginBottom: "1rem",
    },
    loadingText: {
        fontSize: "16px",
        color: "#555",
        fontWeight: 500,
    },
};
